import Link from "next/link";
import { VFC, useEffect, useState } from "react";

import { Hit } from "react-instantsearch-core";
import {
  Hits,
  connectSearchBox,
  Pagination,
  Highlight,
  PoweredBy,
} from "react-instantsearch-dom";

type HitCompoProps = {
  hit: Hit;
};

const HitComponent: VFC<HitCompoProps> = ({ hit }) => {
  return (
    <Link href={`/articles/${hit.objectID}`} prefetch={false}>
      <a className="block">
        <Highlight attribute="title" hit={hit} />
      </a>
    </Link>
  );
};

const SearchResults = connectSearchBox(({ refine, currentRefinement }) => {
  const [isShow, setShow] = useState(false);
  useEffect(() => {
    setShow(!!currentRefinement);
  }, [currentRefinement]);

  const hitComponent: VFC<{ hit: Hit }> = ({ hit }) => (
    <HitComponent hit={hit} />
  );

  const lgCloseResults = ({
    target,
    currentTarget,
  }: {
    target: EventTarget;
    currentTarget: EventTarget;
  }) => {
    if (target === currentTarget) refine("");
  };

  if (!isShow) return null;
  return (
    <div
      onClick={lgCloseResults}
      className="lg:relative lg:left-1/2 lg:h-screen lg:w-screen lg:-translate-x-1/2 lg:transform"
    >
      <div className="lg:dark:bg-dark lg:shadow-light-700 lg:bg-light lg:dark:shadow-dark-400 lg:mx-auto lg:w-[36rem] lg:bg-opacity-95 lg:shadow-lg lg:dark:bg-opacity-95">
        <Hits hitComponent={hitComponent} />
        <Pagination />
        <PoweredBy />
      </div>
    </div>
  );
});

export default SearchResults;
